import React, {ReactNode, Children, cloneElement} from 'react';
import {StyledGrid} from './styled';

interface GridLayoutProps {
    columns?: number;
    children: ReactNode;
    gap?: string;
    style?: React.CSSProperties;
}

const GridLayout: React.FC<GridLayoutProps> = ({
	columns = 5,
	children,
	gap,
	style,
}) => {
	const gridChildren = Children.map(children, (child, idx) => {
		if (
			React.isValidElement(child) &&
            typeof child.type === 'string'
		) {
			const gridArea = `1 / ${idx + 1} / 2 / ${idx + 2}`;
			const props = child.props as React.HTMLAttributes<HTMLElement>;
			return cloneElement(
                child as React.ReactElement<React.HTMLAttributes<HTMLElement>>,
                {
                	style: {...(props.style || {}), gridArea}
                }
			);
		}
		return child;
	});

	return (
		<StyledGrid
			$columns={columns}
			$gap={gap ?? '0px'}
			style={style}
		>
			{gridChildren}
		</StyledGrid>
	);
};

export default GridLayout;